import solver from 'solver-utilities';

const scrollTo = async function () {
	const navItems = document.querySelectorAll('[data-el="policy-nav-item"]');

	if (!navItems || (navItems && !navItems.length)) return;

	navItems.forEach((item) => {
		item.addEventListener('click', async (event) => {
			event.preventDefault();

			const headerHeight = parseInt(solver.frontend.getCSSVariable('--mega-menu-height'));
			const target = event.currentTarget;
			const id = target.getAttribute('data-id');
			const policyItem = document.getElementById(id);
			const top = policyItem.getBoundingClientRect().top + window.pageYOffset - headerHeight;

			window.scrollTo({ top, behavior: 'smooth' });
		});
	});
};

const setNavigation = function () {
	const ul = document.querySelector('[data-el="policy-nav"]');
	const policy = document.querySelector('[data-policy]');

	if (!ul || !policy) return;

	const headings = policy.querySelectorAll('h2');

	headings.forEach((heading, index) => {
		const handle = heading.innerText.toLowerCase().replace(/ /g, '-');
		const template = `<li><a href="#${handle}" data-id="${handle}" data-el="policy-nav-item" title="${heading.innerText}">${heading.innerText}</a></li>`;
		ul.insertAdjacentHTML('beforeend', template);
		heading.id = handle;
	});
};

export const policies = function () {
	setNavigation();
	scrollTo();
};
